import React from 'react';
import ComposeWithTemplate from './ComposeWithTemplate';

const ReminderMessageStep: React.FC = () => (
  <ComposeWithTemplate intent="reminder" />
);

export default ReminderMessageStep;
